import { useCallback, useState } from "react"
import { storeShouldHideProfileStrength } from "utils/local-storage"

export const useIsProfileStrengthHidden = (tennisID) => {
    const [isProfileStrengthHidden, setIsProfileStrengthHidden] = useState(false)

    const hideProfileStrength = useCallback(() => {
        setIsProfileStrengthHidden(true)
        if (tennisID) storeShouldHideProfileStrength(tennisID)
    }, [tennisID])

    return { isProfileStrengthHidden, hideProfileStrength }
}